var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-table-column", {
    attrs: {
      label: _vm.label,
      "class-name": "invoice-type",
      prop: _vm.prop,
      rules: _vm.rules
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(scope) {
          return [
            _c(
              "el-select",
              {
                attrs: {
                  placeholder: _vm.placeholder,
                  disabled: _vm.disabled,
                  autofocus: _vm.autofocus,
                  clearable: false,
                  filterable: true,
                  "filter-method": _vm.filter
                },
                model: {
                  value: scope.row.invoice_type,
                  callback: function($$v) {
                    _vm.$set(scope.row, "invoice_type", $$v)
                  },
                  expression: "scope.row.invoice_type"
                }
              },
              [
                _vm.defaultBlank
                  ? _c("el-option", { attrs: { label: "", value: "" } })
                  : _vm._e(),
                _vm._l(_vm.options, function(item) {
                  return _c(
                    "el-option",
                    {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    },
                    [
                      _c("span", { staticStyle: { float: "left" } }, [
                        _vm._v(_vm._s(item.label))
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }